const versionCompare = (v1, v2) => {
  const v1parts = (v1 || '').split('.');
  const v2parts = (v2 || '').split('.');

  for (let i = 0; i < v1parts.length; i += 1) {
    if (v2parts.length === i) {
      return 1;
    }
    if (v1parts[i] !== v2parts[i]) {
      if (v1parts[i] > v2parts[i]) {
        return 1;
      }
      return -1;
    }
  }
  if (v1parts.length !== v2parts.length) {
    return -1;
  }
  return 0;
};

export {
  // eslint-disable-next-line import/prefer-default-export
  versionCompare,
};
